import { useMutation } from "react-query";
import {
  VehicleStatusRequestParams,
  correctVehicleStatus,
} from "store/api/api";
import { handleAxiosError } from "store/util";
import { MUTATION_KEYS } from "../queryKeys";

const correctVehicleStatusFn = async ({
  rowVersion,
  params,
}: {
  rowVersion: string;
  params: VehicleStatusRequestParams;
}) => {
  return await correctVehicleStatus(rowVersion, params);
};

export function useCorrectVehicleStatus() {
  return useMutation(correctVehicleStatusFn, {
    mutationKey: MUTATION_KEYS.correctVehicleStatus,
    onError: (err) => {
      handleAxiosError(err);
    },
  });
}
